import { Passenger } from '@app/models/micro/passenger.model';

/**
 * Regla vigente de "le falta pasaporte": el pasajero no tiene el pasaporte
 * escaneado, no tiene DOCV y aún figura DOCV entre sus campos opcionales
 * faltantes. Centraliza la lógica que hoy está copiada en tres pantallas
 * (passport, printing-boarding-passes, rb-menu-passenger-selection).
 */
export function isPassportPending(passenger: Passenger): boolean {
  const scanned = passenger?.passengerInfo?.passport?.passportScanned;
  const hasDocv = passenger?.hasDOCV;
  const docvMissing = passenger?.missingCheckinOptionalFields?.includes('DOCV');
  return !scanned && !hasDocv && !!docvMissing;
}

/**
 * Filtra la lista de pasajeros conservando únicamente los que tienen pasaporte
 * pendiente según {@link isPassportPending}.
 */
export function pendingPassportPassengers(passengers: Passenger[]): Passenger[] {
  return (passengers ?? []).filter((passenger) => isPassportPending(passenger));
}
